import gql from 'graphql-tag';

export const addressFieldsFragment = gql`
  fragment AdminAddressFields on Address {
    line1
    postal
    city
    region
    country
  }
`;